import { render } from "./PopupComponent.vue?vue&type=template&id=2c9da186"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__